var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('RIMomentoEscuela',{attrs:{"escuela":1,"titulo":"Reporte RI al momento INBI"}})}
var staticRenderFns = []

export { render, staticRenderFns }